import { IconChevronDown } from "@aksara-ui/icons";
import { Box, Button, Text } from "@aksara-ui/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/Dropdown";
import * as React from "react";
import { useMediaQuery } from "react-responsive";

export interface PaginationFilterProps<T> {
  /** Total limit of pages. */
  limit?: number;
  /** Label in front of select input */
  label?: string;
  /** Label items. */
  items: T[];
  /** Selected item. */
  selectedItem?: T | null;
  /** The change handler for the select. */
  onChange: (changes: T) => void;
}

const PaginationFilter = ({
  limit,
  label = "Show rows",
  items,
  selectedItem = limit,
  onChange,
  ...rest
}: PaginationFilterProps<number>) => {
  const isMobileOrTablet = useMediaQuery({ maxWidth: 768 });
  return (
    <Box
      display="flex"
      flexDirection={isMobileOrTablet ? "column" : "row"}
      alignItems="center"
    >
      <Text scale={300} mr={10} {...rest}>
        {label}
      </Text>
      <DropdownMenu maxWidth={300}>
        <DropdownMenuTrigger>
          <Button
            type="button"
            // size="md"
            icon={IconChevronDown}
            iconPosition="right"
          >
            {selectedItem}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side={"bottom"}>
          {items.map((item) => {
            return (
              <Box key={item} px={"md"}>
                <DropdownMenuItem
                  containerStyle={{
                    minWidth: 64,
                  }}
                  onSelect={() => {
                    onChange(item);
                  }}
                  isActive={item === selectedItem}
                >
                  {item}
                </DropdownMenuItem>
              </Box>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </Box>
  );
};

export default PaginationFilter;
